// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.
import { FileSystem } from '@rushstack/node-core-library';
import { EXTRACTOR_METADATA_FILENAME } from '../../../PathConstants';
export async function getExtractorMetadataAsync() {
    const extractorMetadataPath = `${__dirname}/${EXTRACTOR_METADATA_FILENAME}`;
    const extractorMetadataJson = await FileSystem.readFileAsync(extractorMetadataPath);
    const extractorMetadataObject = JSON.parse(extractorMetadataJson);
    return extractorMetadataObject;
}
//# sourceMappingURL=CreateLinksUtilities.js.map